// extracted by mini-css-extract-plugin
export default {"formButtonWrapper":"Profile_formButtonWrapper__Vts0h","togglePasswordWrapper":"Profile_togglePasswordWrapper__TmPwc","profileContainer":"Profile_profileContainer__ajBjd"};